import { IComboBoxOption, SelectableOptionMenuItemType } from '@fluentui/react';

export function comboBoxUtils(
    option: IComboBoxOption | undefined,
    selectedKeys: string[] = [],
    selectableOptions: IComboBoxOption[],
    setSelectedKeys: (keys: string[]) => void,
    setPageNumber?: (page: number) => void,
    setSelectedKeysInLocalStorage?: (keys: string[]) => void,
    emitMetric?: () => void
) {
    const currentSelectedOptionKeys = selectedKeys.filter(
        (key) => key !== 'selectAll'
    );
    const selectAllState =
        currentSelectedOptionKeys.length === selectableOptions.length;
    let updatedKeys: string[] = [];

    if (option) {
        if (option.itemType === SelectableOptionMenuItemType.SelectAll) {
            if (selectAllState) {
                updatedKeys = [];
                setSelectedKeysInLocalStorage?.([]);
            } else {
                updatedKeys = [
                    'selectAll',
                    ...selectableOptions.map((o) => o.key as string),
                ];
                setSelectedKeysInLocalStorage?.(updatedKeys);
            }
        } else {
            updatedKeys = option.selected
                ? [...currentSelectedOptionKeys, option.key as string]
                : currentSelectedOptionKeys.filter((k) => k !== option.key);
            if (updatedKeys.length === selectableOptions.length) {
                updatedKeys.push('selectAll');
            }
            setSelectedKeysInLocalStorage?.(updatedKeys);
        }
        setSelectedKeys(updatedKeys);
        setPageNumber?.(1);
        emitMetric?.();
    }
}
